import type { DataSourceDto } from "../../services/ApiService";
import type { DataSource, DataSourceSearchType, DataSourceType, DataSourceUpdateStatus } from "../../types/DataSource";
import { dataSourcesByType } from "../../pages/customer/dataSource/dataSourcesByType";
import DataSourceId from "../../state/DataSourceId";
import { isNil } from "lodash-es";

const resolveDataSourceType = (dto: DataSourceDto): DataSourceType => {
  // Data sources currently do not have a reliable 'type' property, so we have to base it on their configuration. This is
  // the same logic as in the old platform and in the `datasource` service.
  if (!isNil(dto.urlConfiguration)) {
    return "URL";
  } else if (!isNil(dto.googleConfiguration)) {
    return "GOOGLE_SPREADSHEET";
  } else {
    return "EXCEL";
  }
};

export const toDataSource = (dto: DataSourceDto): DataSource => {
  const type = resolveDataSourceType(dto);
  const definition = dataSourcesByType[type];

  return {
    id: DataSourceId.from(dto.id),
    name: dto.name,
    type,
    enabled: dto.enabled,
    lastUpdatedAt: isNil(dto.lastUpdated) ? undefined : new Date(dto.lastUpdated),
    updateStatus: dto.updateStatus as DataSourceUpdateStatus,
    lastUpdateWarningMessages: dto.lastUpdateWarningMessages,
    columnMapping: dto.columnMapping,
    searchType: dto.searchType as DataSourceSearchType,
    failedExecutionCount: dto.failedExecutionCount,
    configuration: definition.toConfiguration(dto),
  };
};
